import axios from 'axios';
import { isPreview } from '../helpers/authHelper';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';
export const FETCH_INSIGHTS = {
  FETCH_INSIGHTS: 'FETCH_INSIGHTS',
  FETCH_INSIGHTS_FAILED: 'FETCH_INSIGHTS_FAILED'
};

export function fetchInsightsWidgetData(uuid, translations, dateFormat, templateName, locale) {
  let params = {
    "date-format": dateFormat,
    "locale": locale
  };
  if(isPreview()){
    params.templateName = templateName;
  }
  return dispatch => {
    axios.get(API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/users/' + uuid + '/insight-feed-data', {
      params
    }).then(
      (response) => {
        dispatch({
          type: FETCH_INSIGHTS.FETCH_INSIGHTS,
          payload: {
            response: response.data.payload,
            translations: translations
          }
        })
      },
      (error) => {
        dispatch({
          type: FETCH_INSIGHTS.FETCH_INSIGHTS_FAILED,
          payload: {
            ...error,
            translations: translations
          }
        })
      }
    )
  }
}
